/** @jsxImportSource @emotion/react */
import React from 'react'
import {
  teamsContainerStyle,
  teamInfoStyle,
  teamLogoStyle,
  teamNameStyle,
  vsTextStyle,
} from '../styles'

const PLACEHOLDER_TEAM = '/images/generic_placeholders/placeholder_team.png'

/**
 * Props for the TeamsContainer component
 */
export interface TeamsContainerProps {
  /** Home team display data */
  homeTeam: {
    name: string
    logo: string
  }
  /** Away team display data */
  awayTeam: {
    name: string
    logo: string
  }
}

/**
 * Displays home and away team logos and names with a "VS" separator.
 *
 * @param {TeamsContainerProps} props - Component props
 * @returns {JSX.Element} Team matchup display
 */
const TeamsContainer: React.FC<TeamsContainerProps> = ({
  homeTeam,
  awayTeam,
}) => {
  return (
    <div css={teamsContainerStyle}>
      <div css={teamInfoStyle}>
        <img
          css={teamLogoStyle}
          src={homeTeam?.logo || PLACEHOLDER_TEAM}
          alt={homeTeam?.name || 'Placeholder'}
          onError={(e) => {
            e.currentTarget.src = PLACEHOLDER_TEAM
          }}
        />
        <p css={teamNameStyle}>{homeTeam?.name || 'Placeholder'}</p>
      </div>
      <span css={vsTextStyle}>VS.</span>
      <div css={teamInfoStyle}>
        <img
          css={teamLogoStyle}
          src={awayTeam?.logo || PLACEHOLDER_TEAM}
          alt={awayTeam?.name || 'Placeholder'}
          onError={(e) => {
            e.currentTarget.src = PLACEHOLDER_TEAM
          }}
        />
        <p css={teamNameStyle}>{awayTeam?.name || 'Placeholder'}</p>
      </div>
    </div>
  )
}

export default React.memo(TeamsContainer)
